import AgencyDashboard from './AgencyDashboard.vue';

export default [
  {
    path: 'agency',
    component: AgencyDashboard,
    props: true,
  },
];
